// removed by extract-text-webpack-plugin
module.exports = {"menu":"_3STD3","closed":"_2bl8g _3STD3","open":"_1c88H _3STD3","item":"_5qhMB","link":"n7CC9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu.css
// module id = 806
// module chunks = 0